import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// Components
import AjaxController from '../system/ajaxController';

// Redux slices
import { confimChanges, setObjectData, setMetaData, setObjectID, resetObject, setCurrentChangeNr, deleteLastChange } from '../object/objectSlice';
import { setActivePage, setUser, setToken } from '../../appSlice';

// Semantic UI components
import { Button, Icon, Menu, MenuItem, MenuMenu, Modal, Segment, Header, HeaderContent } from 'semantic-ui-react';

// Styles
import 'semantic-ui-css/semantic.min.css';



const Max2ObjectSubmenu = () => {
    // local State
        const [showSave, setShowSave] = useState(false);

    // global state
    const dispatch = useDispatch();
    const objectData      = useSelector((state) => state.object.data);
    const objectId        = useSelector((state) => state.app.objectId);
    const dataChanges     = useSelector((state) => state.object.dataChanges);
    const currentChangeNr = useSelector((state) => state.object.currentChangeNr);
  
    const isDirtyObject   = useSelector((state) => state.object.isDirty);
    const backendUrl      = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

    // Snackbar
    const { enqueueSnackbar } = useSnackbar();




    /**
     * Remove lock function
     * 
     * @async 
     */
    const removeLock = async () => {
        // init AJAX controller
        const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
        });

        // remove lock
        let response;
        try {
        response = await api.delete('/hotel/'+objectId+'/unlock');
        if (response.status !== 'success') {
            enqueueSnackbar('Fehler beim widerrufen der Zugangssperre', { variant: 'error' });
            return;
        }
        } catch (error) {
            enqueueSnackbar('Fehler beim widerrufen der Zugangssperre', { variant: 'error' });
            return;
        }
    }
    


    /**
     * @async
     */
    const handleConfimClick = async () => {
        try {
            setShowSave(true);

            // Controller for AJAX requests
            const api = new AjaxController(backendUrl, () => {
                dispatch(setActivePage('START'));
                dispatch(setUser(null));
                dispatch(setToken(null));
            });
    
            // send post request
            if (objectId === '__new__') {
                const response = await api.post('/hotel/new', objectData);
                if (response?.status === 'success') {
                    enqueueSnackbar('Hoteldaten wurden gespeichert', { variant: 'success' });
                    dispatch(confimChanges())
                    dispatch(setObjectID(response?.id));
                    if (typeof response.object === 'object') {
                        dispatch(setObjectData(response.object));
                    }
                    if (typeof response.meta === 'object') {
                        dispatch(setMetaData(response.meta));
                    }
                    removeLock();
                } else {
                    enqueueSnackbar('Fehler beim Speichern der Hoteldaten', { variant: 'error' });
                }
                setShowSave(false);
                return;
            }

            // send put request
            const response = await api.put('/hotel/' + objectId, objectData);
            if (response?.status === 'success') {
                enqueueSnackbar('Hoteldaten wurden gespeichert', { variant: 'success' });
                dispatch(confimChanges())
                removeLock();
            } else {
                enqueueSnackbar('Fehler beim Speichern der Hoteldaten', { variant: 'error' });
            }
            setShowSave(false);
        } catch (err) {
            enqueueSnackbar('Fehler beim Speichern der Hoteldaten', { variant: 'error' });
            console.error(err.message);
            setShowSave(false);
        }
    }



    /**
     * 
     */
    const handleAbortClick = () => {
        dispatch(resetObject())
        removeLock();
    }



    /**
     * 
     */
    const handleDiscardLastChangeClick = () => {
        dispatch(deleteLastChange())
    }



    /**
     * 
     */
    const handlePrevChangeClick = () => {
        if (currentChangeNr > 1) {
            const prevChangeNr = currentChangeNr - 1;
            const currChange = dataChanges[prevChangeNr-1];
            dispatch(setObjectData(currChange))
            dispatch(setCurrentChangeNr(prevChangeNr));
        }
    }


    /**
     * 
     */
    const handleNextChangeClick = () => {
        if (currentChangeNr < dataChanges.length) {
            const nextChangeNr = currentChangeNr + 1;
            const currChange = dataChanges[nextChangeNr - 1];
            dispatch(setObjectData(currChange))
            dispatch(setCurrentChangeNr(nextChangeNr));
        }
    }



    if (!isDirtyObject) {
        return <></>
    }

    return (
        <>
        {/* Modal für Speicher-Dialog */}
        <Modal
            closeIcon
            open={showSave}
            onClose={() => setShowSave(false)}
            size='medium'
        >
            <Modal.Content>
                <Segment>
                    <br />
                    <br />
                    <Header as='h2' textAlign='center'>
                    <Icon loading name='spinner' />
                    <HeaderContent>
                        Hoteldaten werden gespeichert...
                    </HeaderContent>
                    </Header>
                    <br />
                    <br />
                </Segment>
            </Modal.Content>
        </Modal>
        <Menu borderless size='mini' style={{margin: '5px 15px 5px 5px', background: 'rgb(51, 51, 51)', borderRadius: '25px', border: '1px solid #555', padding: '5px'}}>
            <MenuItem style={{color: '#eee', fontSize: '10pt', fontWeight: 'bolder'}}>Änderungen:</MenuItem>
            <MenuMenu position='right'>
                <MenuItem>
                    {dataChanges.length > 1 && (<Button icon circular onClick={()=>handlePrevChangeClick()}><Icon name='undo' /></Button>)}
                </MenuItem>
                <MenuItem style={{color: '#eee', fontSize: 'small', fontWeight: 'bolder'}}>{currentChangeNr} / {dataChanges.length}</MenuItem>
                <MenuItem>
                    {dataChanges.length > 1 && (<Button icon circular onClick={()=>handleNextChangeClick()}><Icon name='redo' /></Button>)}
                </MenuItem>
            </MenuMenu>
            <MenuMenu position='right'>
                <MenuItem>
                    <Button icon circular labelPosition='left' onClick={()=>handleDiscardLastChangeClick()}>
                        <Icon name='undo' />
                        Letzte verwerfen
                    </Button>
                </MenuItem>
                <MenuItem>
                    <Button icon circular labelPosition='left' onClick={()=>handleAbortClick()}>
                        <Icon name='undo' />
                        Alle verwerfen
                    </Button>
                </MenuItem>
                <MenuItem>
                    <Button icon circular labelPosition='left' primary onClick={()=>handleConfimClick()}>
                        Speichern
                        <Icon name='save' />
                    </Button>
                </MenuItem>
            </MenuMenu>
        </Menu>
        </>
    )
}

export default Max2ObjectSubmenu;